import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  constructor() {
  }

  public navOpen = false;

}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/app.component.ts